import { render } from "./Badge3dTour.vue?vue&type=template&id=6a84e5a4"
import script from "./Badge3dTour.vue?vue&type=script&lang=js"
export * from "./Badge3dTour.vue?vue&type=script&lang=js"
script.render = render

export default script